// extracted by mini-css-extract-plugin
module.exports = {"offset":"Offset_offset__kC9qa","load":"Offset_load__WjUdb"};